<template>
	<div class="m-product">
		<div v-if="unitData.show_title == 1" class="m-product-head flex-between-center">
			<p :style="{'font-size': `${(unitData.title_size || 36) / 2}px`}">{{unitData.title_text}}</p>
			<span v-if="unitData.more_link" class="more">{{unitData.more_text || '查看更多'}}</span>
		</div>
		<div class="m-product-list flex">
			<ul class="flex-wrap">
				<li v-for="(item, i) in list" :key="item.product_id">
					<sub-image class="image" :src="item.product_img_url"></sub-image>
					<p class="name ellipsis">{{item.product_name}}</p>
					<p v-if="unitData.is_point == 1" class="price">{{item.sale_price}}积分</p>
					<p v-else class="price">￥{{item.sale_price}}</p>
				</li>
				<li v-if="unitData.show_all == 1">
					<div class="more flex-column flex-center">
						<p>查看全部</p>
						<span>VIEW ALL</span>
					</div>
				</li>
			</ul>
		</div>
		<div class="flex-center m-product-nav">
			<div v-for="(item, i) in nav" :key="i" class="item" :class="{'z-hl': i == 0}"></div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				unitData: {},
				nav: new Array(3)
			}
		},
		
		computed: {
			list() {
				if (this.unitData.product_list) {
					return this.unitData.product_list.splice(0, this.unitData.lines * 3 - (this.unitData.show_all == 1 ? 1 : 0));
				}
				return [];
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.m-product {
		border-radius: 10px;
		margin: 0 12px;
		overflow: hidden;
		background: #fff;
		
		&-head {
			box-sizing: border-box;
			height: 40px;
			padding: 6px 12px 0;
			
			p {
				font-size: 18px;
				font-weight: bold
			}
			
			.more {
				font-size: 12px;
				color: #999;
			}
		}
		
		&-list {
			margin: 6px 10px;
			overflow: hidden;
			
			ul {
				float: left;
				
				li {
					width: 106px;
					margin-left: 6px;
					
					&:nth-child(3n+1) {
						margin-left: 0;
					}
					
					&:nth-child(n+4) {
						margin-top: 20px;
					}
					
					.image {
						height: 108px;
					}
					
					.name {
						line-height: 24px;
						font-size: 12px;
						text-align: center;
						color: #666;
					}
					
					.price {
						margin-top: 4px;
						font-size: 15px;
						font-weight: bold;
						text-align: center;
					}
					
					.more {
						height: 62px;
						width: 54px;
						border: 1px solid #666;
						border-width: 1px 0;
						margin: 23px auto 0;
						font-size: 13px;
						text-align: center;
						white-space: nowrap;
						
						span {
							margin-top: 8px;
							font-size: 11px;
							color: #999;
						}
					}
				}
			}
		}
		
		&-nav {
			height: 36px;
			
			.item {
				width: 4px;
				height: 4px
				border-radius: 100%;
				margin: 0 3px;
				background: #ddd;
				
				&.z-hl {
					background: #000;
				}
			}
		}
	}
</style>
